<hlm-dialog-header>
  <h3 hlmDialogTitle>Choisissez votre Centre de Formation</h3>
</hlm-dialog-header>

<div class="p-md gap-lg grid">
  <p>
    Le Centre de Formations que vous choisirez sera valable uniquement pour la sélection des offres de la région.<br />En
    ajoutant d’autres formations, vous devrez de nouveau choisir le Centre de Formations que vous souhaitez.
  </p>

  <div class="flex flex-col gap-2">
    <label hlmLabel for="select-cfa">Centre de Formation</label>
    <hlm-select id="select-cfa" [(ngModel)]="site" scrollable="true" placeholder="Sélectionner un centre de formation">
      <hlm-select-trigger>
        <hlm-select-value />
      </hlm-select-trigger>
      <hlm-select-content>
        <hlm-select-scroll-up />

        @for (region of regions() | trierPar: 'nom'; track region.id; let last = $last) {
          <hlm-select-group>
            <hlm-select-label>{{ region.nom }}</hlm-select-label>
            @for (site of region.sites | trierPar: 'nom'; track site.id) {
              <hlm-option class="!pl-xl" [value]="site">{{ site.nom }}</hlm-option>
            }
          </hlm-select-group>
          @if (!last) {
            <div class="border-background-underground-2 mb-xxs border-b"></div>
          }
        }

        <hlm-select-scroll-down />
      </hlm-select-content>
    </hlm-select>
  </div>
</div>

<hlm-dialog-footer class="p-md flex w-full justify-between">
  <button brnDialogClose hlmBtn variant="secondary" type="button">Annuler</button>
  <button (click)="close()" hlmBtn type="button">Confirmer le choix</button>
</hlm-dialog-footer>
